import { Grid, Header, Divider, Form } from 'semantic-ui-react';
import { submit, formValueSelector } from 'redux-form';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { get, has } from 'lodash';

import { VENDORLINK_PREVIEW_FORM_NAME } from 'Common/FormEnum';
import { StudentProfileEnum } from 'Common/FieldEnum';
import { TitledCard } from 'Components/';
import {
  VendorLinkMapOptions,
  vendorLinkPreviewFields,
} from 'Common/Constants/SISIntegration';

import * as VendorLinkIntegrationActions from 'Pages/vendorlinkintegration/state/actions';
import { VendorLinkPreviewForm } from './VendorLinkPreviewForm';
import Spinner from '../LoadingComponents/CircularSpinner';
import 'Styles/pages/vendorlinkintegration/preview.less';
import * as Helpers from '../../helpers/helper';

export class VendorLinkPreviewContainer extends Component {
  reducePreviewData = data => {
    const { gradeOptions, siteOptions, languageOptions } = this.props;

    const formatters = {
      [StudentProfileEnum.LanguageId]: key => {
        const language = languageOptions.find(l => l.key === data[key]);
        if (language) {
          return { key: VendorLinkMapOptions.Language, value: language.text };
        }
        return getDefault(key);
      },
      Site: key => {
        const site = siteOptions.find(i => i.key === data[key]);
        if (site) {
          return { key, value: site.text };
        }
        return getDefault(key);
      },
      Grade: key => {
        const grade = gradeOptions.find(i => i.key === data[key]);
        if (grade) {
          return { key, value: grade.text };
        }
        return getDefault(key);
      },
    };

    const getDefault = valueAndList => {
      const myKey = Object.keys(valueAndList.list).find(
        key => valueAndList.list[key] === valueAndList.item
      );
      return { key: valueAndList.item, value: data[myKey] };
    };

    return Object.values(vendorLinkPreviewFields)
      .map(value =>
        get(
          formatters,
          value,
          getDefault
        )({ item: value, list: vendorLinkPreviewFields })
      )
      .filter(i => i.key !== vendorLinkPreviewFields.VLEnrollStatus);
  };

  render() {
    const {
      handleKeyDown,
      onSubmit,
      onChange,
      loading,
      config,
      data,
    } = this.props;

    let reducedData = null;

    if (data) {
      reducedData = this.reducePreviewData(data);
    }

    return (
      <React.Fragment>
        <Form>
          <TitledCard title="Single Student Preview">
            <VendorLinkPreviewForm
              handleKeyDown={handleKeyDown}
              onSubmit={onSubmit}
              onChange={onChange}
              loading={loading}
            />
            {reducedData && !loading && (
              <React.Fragment>
                <Divider />
                <Grid className={'vendorlink-preview'}>
                  {reducedData.map(item => {
                    return (
                      <Grid.Column width="4" key={item.key}>
                        <div
                          className={classNames(item.key, {
                            null:
                              has(item, 'value') &&
                              !item.value &&
                              Helpers.getItemValue(item, config) ===
                                '(No Data Available)',
                            skipped:
                              has(item, 'value') &&
                              Helpers.getItemValue(item, config) ===
                                '(Skipped)',
                          })}
                        >
                          <Header as="h5">{item.key}</Header>
                          {Helpers.getItemValue(item, config)}
                        </div>
                      </Grid.Column>
                    );
                  })}
                  <Grid.Row />
                </Grid>
              </React.Fragment>
            )}
            {loading && <Spinner />}
          </TitledCard>
        </Form>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  submit: () => submit(VENDORLINK_PREVIEW_FORM_NAME),
  getPreview: VendorLinkIntegrationActions.getStudentPreview,
  importStudent: VendorLinkIntegrationActions.importStudent,
};

const mapStateToProps = state => ({
  studentId: formValueSelector(VENDORLINK_PREVIEW_FORM_NAME)(
    state,
    VendorLinkMapOptions.StudentId
  ),
});

export const VendorLinkPreview = connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorLinkPreviewContainer);



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/components/VendorLinkPreviewStep/VendorLinkPreview.js